export default (value) => {
  if (value && !value.match(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$/)) {
    return 'At least 8 characters including a lowercase letter, an uppercase letter, and a number';
  }
  return null;
};
